/* eslint-disable radix */
/* eslint-disable camelcase */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiClient from 'src/api/api-client';
import { uploadFileURI, reviewURI, detailReviewURI } from '../api';
import { setDefaultValue } from './ReviewItemSlice';
import { setValue } from './MessageSlice';

// First, create the thunk
export const fetchReviews = createAsyncThunk(
  'reviews/fetchReviews',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'get',
          url: `${reviewURI}`,
          params: { ...params, get_all: true },
        })
        .then(res => res.data);
      return response.data;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const detailReview = createAsyncThunk(
  'reviews/detailReview',
  async (id, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await apiClient.handleRequest({
        method: 'get',
        url: `${detailReviewURI(id)}`,
      });
      dispatch(
        setDefaultValue({
          ...response.data.data,
        }),
      );
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const upsertReview = createAsyncThunk(
  'reviews/upsertReview',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      await apiClient.handleRequest({
        method: data.id ? 'put' : 'post',
        url: `${detailReviewURI(data.id)}`,
        data: data.data,
      });
      if (data.id) {
        dispatch(setValue({ show: true, body: 'Cập nhật thành công', color: 'success' }));
      } else {
        dispatch(setValue({ show: true, body: 'Tạo mới thành công', color: 'success' }));
      }

      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const deleteReview = createAsyncThunk(
  'service/upsertService',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      await apiClient
        .handleRequest({
          method: 'delete',
          url: `${detailReviewURI(data.id)}`,
        })
        .then(res => res.data);
      dispatch(fetchReviews({ page: 1 }));
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const uploadImage = createAsyncThunk(
  'service/uploadFile',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'post',
          url: uploadFileURI,
          data: data.data,
        })
        .then(res => res.data);
      const dataCurrent = getState().serviceItem;
      if (data.type === 'image') {
        dispatch(setDefaultValue({ ...dataCurrent, image: response }));
      } else {
        dispatch(setDefaultValue({ ...dataCurrent, banner: response }));
      }
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);
export const uploadOurPartner = createAsyncThunk(
  'service/uploadOurPartner',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'post',
          url: uploadFileURI,
          data: data.data,
        })
        .then(res => res.data);
      const dataCurrent = getState().serviceItem;
      dispatch(
        setDefaultValue({ ...dataCurrent, our_partner: [...dataCurrent.our_partner, response] }),
      );
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

// Then, handle actions in your reducers:
const reviewSlice = createSlice({
  name: 'review',
  initialState: {
    entities: [],
    loading: 'idle',
    saving: 'idle',
    saving_id: 0,
    currentRequestId: undefined,
    error: null,
    currentPage: 1,
    totalPage: 1,
    total: 0,
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    [fetchReviews.pending]: (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchReviews.fulfilled]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        const { data, last_page, current_page, total } = action.payload;
        state.loading = 'idle';
        state.entities = data;
        state.currentPage = current_page;
        state.totalPage = last_page;
        state.currentRequestId = undefined;
        state.total = total;
      }
    },
    [fetchReviews.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
    [upsertReview.pending]: (state, action) => {
      if (state.saving === 'idle') {
        state.saving = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    [upsertReview.fulfilled]: (state, action) => {
      state.saving = 'idle';
    },
    [upsertReview.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.saving === 'pending' && state.currentRequestId === requestId) {
        state.saving = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
  },
});

export default reviewSlice.reducer;
